import React from "react";
import { LinearProgress } from "@mui/material";

import AutoComplete from "components/Custom/AutoComplete";
import Btn from "components/Custom/Btn";
import Loader from "components/Custom/Loader";
import UiDialog from "components/Custom/UiDialog";
import { LABELS } from "common/labels";
import { ApiIndents } from "apihandlers/indent";

const API_HANDLER_INDENT = new ApiIndents();

const Radar = (props: any) => {
  const {
    showRadar,
    setShowRadar,
    setNearVehicles,
    setClustering,
    setShowAreas,
    setRadarLoading,
    setRadarData,
    setRadarMainVehicle,
    vehiclesList,
    vehiclesRef,
    radarLoading,
  } = props;

  const getTrackedVehicle = () => {
    setShowRadar(false);
    const vehicleId = vehiclesRef.current.selectedValue.id;
    const args = {
      vehicleId,
    };
    API_HANDLER_INDENT.getVehicleOnRadar(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        const vehicleRadar = response;
        let vehicleNearby = [];

        // Here response is object inside object hence for loop is used to push only the km to a array
        for (const key in vehicleRadar.ranges) {
          if (vehicleRadar.ranges.hasOwnProperty(key)) {
            const range = vehicleRadar.ranges[key];
            const km = range.km;
            vehicleNearby.push(km);
          }
        }
        setNearVehicles(vehicleNearby);
        const vehList = [];

        // here only the first vehicle data is taken and pushed to a array ,used to diffrentiate from the surrounding vehicles
        vehList.push(vehicleRadar);
        const firstVehicle = vehList.map((obj) => ({
          ...obj,
          lat: parseFloat(obj.latitude),
          lng: parseFloat(obj.longitude),
        }));

        setRadarMainVehicle(firstVehicle);
        console.log("vehList :", firstVehicle);

        const raderList = [];
        // Here response is object inside object hence for loop is used to push the data to a array
        for (const vehicles in vehicleRadar.ranges) {
          if (vehicleRadar.ranges.hasOwnProperty(vehicles)) {
            const range = vehicleRadar.ranges[vehicles];
            if (range.vehicles && Array.isArray(range.vehicles)) {
              raderList.push(...range.vehicles);
            }
          }
        }
        let latLngRadar = raderList.map((latlng, i) => {
          return {
            ...latlng,
            lat: parseFloat(latlng.latitude),
            lng: parseFloat(latlng.longitude),
          };
        });
        setClustering(false);
        setShowAreas(false);
        setRadarData(latLngRadar);
      }
    });
  };

  const getOverlayLoader = () => {
    setRadarLoading(true);
    setTimeout(() => {
      setRadarLoading(false);
    }, 4000);
  };

  return (
    <>
      {showRadar && (
        <UiDialog
          title={LABELS.LOCATE_VEHICLE}
          open={true}
          size={"xs"}
          onClose={() => {
            setShowRadar(!showRadar);
          }}
        >
          <div className="formGroup" style={{ marginTop: "-10px" }}>
            <label>{LABELS.VEHICLE_NO}</label>
            <div className="formGroup ">
              <AutoComplete
                list={vehiclesList}
                childRef={vehiclesRef}
                placeholder={LABELS.SELECT_VEHICLES}
              />
            </div>
            <div className="flexRowJustify">
              <div className="formGroup"></div>
              <Btn
                text={LABELS.LOAD}
                onClick={() => {
                  getTrackedVehicle();
                  getOverlayLoader();
                }}
              />
              <div className="formGroup"></div>
            </div>
          </div>
        </UiDialog>
      )}
      {radarLoading && (
        <>
          <div className="progressBar">
            <LinearProgress />
          </div>
          <div className="radarOverLay">
            <Loader size="40px"></Loader>

            <p className="bold">Please wait</p>
          </div>
        </>
      )}
    </>
  );
};

export default Radar;
